var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "mr-11 ml-n3 mt-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "overflow-y": "hidden",
      "white-space": "nowrap"
    }
  }, [_c('draggable', {
    attrs: {
      "list": _vm.documents,
      "handle": ".handle"
    },
    on: {
      "change": _vm.handleOrderChange
    }
  }, _vm._l(_vm.documents, function (document, index) {
    return _c('v-hover', {
      key: 'v-hover' + index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var hover = _ref.hover;
          return [_c('div', {
            staticStyle: {
              "display": "inline-block",
              "float": "none"
            }
          }, [_c('v-btn', {
            class: _vm.tab === index ? 'highlighted' : '',
            attrs: {
              "text": "",
              "elevation": 0
            },
            on: {
              "click": function click($event) {
                _vm.tab = index;
              }
            }
          }, [document.isLoading ? _c('v-skeleton-loader', {
            staticClass: "mb-n1 mt-1",
            attrs: {
              "type": "text",
              "width": "100"
            }
          }) : document.document ? _c('div', {
            staticClass: "mr-3"
          }, [_vm.documents.length > 1 && (hover || _vm.isMobile) ? _c('v-icon', {
            staticClass: "handle"
          }, [_vm._v(" mdi-drag-vertical ")]) : _vm._e(), _c('span', {
            class: !(_vm.documents.length > 1 && (hover || _vm.isMobile)) ? 'ml-1' : ''
          }, [_vm._v(" " + _vm._s(document.document.title) + " ")])], 1) : _c('div', [_vm._v(" - ")])], 1)], 1)];
        }
      }], null, true)
    });
  }), 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mb-n1 mt-1",
    attrs: {
      "small": "",
      "text": "",
      "elevation": 0,
      "loading": _vm.loading || _vm.isLoadingCreation
    },
    on: {
      "click": function click($event) {
        _vm.isDocumentDialogActive = true;
      }
    }
  }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.fleet.FleetVehicleDetailDocumentCard.addDocumentDialogTitle")))])])], 1)])], 1), _vm.documents && _vm.documents[_vm.tab] ? _c('v-card', {
    attrs: {
      "outlined": "",
      "elevation": 0
    }
  }, [_vm.documents[_vm.tab].isLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : !_vm.documents[_vm.tab].document ? _c('latest-entries-card-empty') : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.documents[_vm.tab].coverImage,
      "aspect-ratio": "1",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('m-detail-table', {
    attrs: {
      "title": _vm.$t('about'),
      "i18nPath": "objects.document",
      "item": _vm.documents[_vm.tab].document,
      "config": _vm.documentTable,
      "showMoreAction": _vm.costTableAction
    },
    on: {
      "actionClicked": function actionClicked(action) {
        return _vm.processAction(action, _vm.documents[_vm.tab].document);
      }
    },
    scopedSlots: _vm._u([{
      key: "slot.tags",
      fn: function fn() {
        return _vm._l(_vm.documents[_vm.tab].document.tags, function (tag) {
          return _c('v-chip', {
            key: 'slot.tags.' + tag,
            staticClass: "mr-1"
          }, [_vm._v(" " + _vm._s(tag) + " ")]);
        });
      },
      proxy: true
    }, {
      key: "slot.isTemplate",
      fn: function fn() {
        return [_c('v-icon', [_vm._v(" " + _vm._s(_vm.documents[_vm.tab].document.isSigned ? "mdi-signature-freehand" : _vm.documents[_vm.tab].document.isTemplate ? "mdi-file-multiple-outline" : "mdi-file-document-outline") + " ")]), _vm._v(" " + _vm._s(_vm.documents[_vm.tab].document.isSigned ? _vm.$t("sign.DocumentDetail.signed") : _vm.documents[_vm.tab].document.isTemplate ? _vm.$t("sign.DocumentDetail.template") : _vm.$t("sign.DocumentDetail.file")) + " ")];
      },
      proxy: true
    }], null, false, 3152521963)
  }), _c('div', {
    staticClass: "pl-4 pr-4 mt-n1 mb-1"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "block": "",
      "outlined": "",
      "color": "error"
    },
    on: {
      "click": function click($event) {
        _vm.isRemoveDocumentDialogActive = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("remove")) + " ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.isDocumentDialogActive ? _c('document-selection-dialog', {
    attrs: {
      "folder": "/cost/".concat(_vm.costId),
      "isDialogActive": _vm.isDocumentDialogActive,
      "reference": _vm.documentReference,
      "partnerId": _vm.partnerId,
      "createActivityOnSelect": false
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDocumentDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDocumentDialogActive = $event;
      },
      "created": _vm.onCreated
    }
  }) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isRemoveDocumentDialogActive,
      "subtitle": 'Dokument aus Kostenobjekt entfernen'
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isRemoveDocumentDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isRemoveDocumentDialogActive = $event;
      },
      "rightClick": function rightClick() {
        return _vm.removeDocuments(_vm.tab);
      },
      "leftClick": function leftClick() {
        return _vm.isRemoveDocumentDialogActive = false;
      },
      "close": function close() {
        return _vm.isRemoveDocumentDialogActive = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }